import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { DataRunsReducerType } from 'redux/reducers/internal/DataRuns'

export const selectInternalDataRuns = createSelector(
  [
    (state: ApplicationState): DataRunsReducerType =>
      state.InternalDataRunsStore
  ],
  (store) => store
)

/**
 * UI-facing aliases for the wire types. Components should import these
 * rather than reaching into `redux/api/internal/DataRuns/contract`
 * directly, so that file stays the only place referencing the wire
 * contract's exact export names (see its header comment).
 */
export type {
  TJobStatus as JobStatus,
  TJobCustomerRefDto as JobCustomerRef,
  TJobHistoryEntryDto as JobHistoryEntry,
  TJobSummaryDto as JobSummary,
  TRunningPhase as RunningPhase,
  TRunningJobDto as RunningJob,
  TAggregatesDto as Aggregates,
  TOrderWarningKind as OrderWarningKind,
  TOrderWarningDto as OrderWarning,
  TWorkflowIncludedJobDto as WorkflowIncludedJob,
  TWorkflowSummaryDto as WorkflowSummary,
  TFileDeliveryStatus as FileDeliveryStatus,
  TFileDeliveryPattern as FileDeliveryPattern,
  TFileDeliveryHistoryEntryDto as FileDeliveryHistoryEntry,
  TFileDeliveryDto as FileDelivery,
  TFileDeliveryAggregatesDto as FileDeliveryAggregates,
  TDataRunsDto as DataRunsData
} from 'redux/api/internal/DataRuns/contract'
